import { render, staticRenderFns } from "./ProduceAdd.vue?vue&type=template&id=4e8919bd&scoped=true&"
import script from "./ProduceAdd.vue?vue&type=script&lang=js&"
export * from "./ProduceAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProduceAdd.vue?vue&type=style&index=0&id=4e8919bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8919bd",
  null
  
)

export default component.exports